import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE, PAGE_KEY, PAGE_SIZE_KEY, SORT_DEFAULT, SORT_KEY } from './constants';
import { PaginationQuery, SortOptions } from './model';

export const getPaginationFilterObject = (queryFromUrl: Record<string, string> = {}): PaginationQuery => {
    return {
        currentPage: parseInt(queryFromUrl[PAGE_KEY]) || DEFAULT_PAGE,
        pageSize: parseInt(queryFromUrl[PAGE_SIZE_KEY]) || DEFAULT_PAGE_SIZE,
        sort: (queryFromUrl[SORT_KEY] as SortOptions) || SORT_DEFAULT,
    };
};

export const getPaginationFilterUrl = (queryObject: Partial<PaginationQuery & { page: number }>, path: string) => {
    const currentPage = queryObject.currentPage || queryObject.page || DEFAULT_PAGE;
    const pageSize = queryObject.pageSize || DEFAULT_PAGE_SIZE;
    const sort = queryObject.sort || SORT_DEFAULT;

    const newQuery = new URLSearchParams({
        ...(currentPage !== DEFAULT_PAGE && { [PAGE_KEY]: `${currentPage}` }),
        ...(pageSize !== DEFAULT_PAGE_SIZE && { [PAGE_SIZE_KEY]: `${pageSize}` }),
        ...(sort !== SORT_DEFAULT && { [SORT_KEY]: sort }),
    });

    return newQuery.toString() ? `${path}?${newQuery}` : path;
};
